import { render, staticRenderFns } from "./gradeRecord.vue?vue&type=template&id=be824e0e"
import script from "./gradeRecord.vue?vue&type=script&lang=js"
export * from "./gradeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports